import { GitMerge, GitPullRequest, GitPullRequestClosed, GitPullRequestDraft } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { LinkedPr } from '@/types/github'

function prIcon(pr: LinkedPr) {
  if (pr.state === 'MERGED') return { Icon: GitMerge, label: 'merged' }
  if (pr.state === 'CLOSED') return { Icon: GitPullRequestClosed, label: 'closed' }
  if (pr.isDraft) return { Icon: GitPullRequestDraft, label: 'draft' }
  return { Icon: GitPullRequest, label: 'open' }
}

/** At-a-glance PR linkage: one clickable, state-specific icon per linked PR,
 *  each with a tooltip naming it. The icon (not colour) carries the state. */
export function LinkedPrIcons({ prs, className }: { prs: LinkedPr[]; className?: string }) {
  if (prs.length === 0) return null
  return (
    <span className={cn('flex items-center gap-1', className)}>
      {prs.map((pr) => {
        const { Icon, label } = prIcon(pr)
        return (
          <a
            key={pr.number}
            href={pr.url}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            title={`${pr.repo}#${pr.number} · ${label} — ${pr.title}`}
            aria-label={`${pr.repo}#${pr.number} ${label}: ${pr.title}`}
            className="text-muted-foreground hover:text-foreground"
          >
            <Icon className="size-3.5" />
          </a>
        )
      })}
    </span>
  )
}
